import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';

export const trackMapModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'map modal'
    });
};

export const trackStreetViewModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'streetview modal'
    });
};

export const trackMarketStatsModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'market stats modal'
    });
};

export const trackFloorPlansModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'floorplan gallery'
    });
};

export const trackVirtualToursModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'video gallery'
    });
};

export const trackEnergyPerfCertModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'epc gallery'
    });
};

export const trackSharingModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'share links modal'
    });
};

export const trackTenancyInfoModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'tenancy information'
    });
};

export const trackGuidePriceModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'guide price'
    });
};

export const trackAdditionalLinksModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'additional links modal'
    });
};

export const trackListingHistoryModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'listing history modal'
    });
};

export const trackSmartViewingsModalClose = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'close',
        eventLabel: 'smart viewing'
    });
};
